import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "picture_in_picture_alt",
  "use": "picture_in_picture_alt-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"picture_in_picture_alt\"><path d=\"M25.333 14.667H14.666v8h10.667v-8zm5.334 10.666V6.64C30.667 5.173 29.467 4 28 4H4C2.533 4 1.333 5.173 1.333 6.64v18.693C1.333 26.8 2.533 28 4 28h24c1.467 0 2.667-1.2 2.667-2.667zM28 25.36H4V6.627h24V25.36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol